<div [ngClass]="{'has-background-link': logado, 'has-background-white' : !logado }">
    <div class="container is-fullhd">
        <nav class="navbar pl-2 pr-2" [ngClass]="{'is-link': logado, 'is-white' : !logado }" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                <a class="navbar-item" href="https://perpetue.me">
                    <div *ngIf="logado">
                        <img src="./../../../assets/images/perpetueme-marca-branco.svg" width="150">
                    </div>
                    <div *ngIf="!logado">
                        <img src="./../../../assets/images/perpetueme-marca.svg" width="150">
                    </div>
                </a>
            </div>

            <div class="navbar-menu">
                <div class="navbar-start">
                </div>
            
                <div *ngIf="logado" class="navbar-end">                

                    <a class="navbar-item" *ngIf="isPendencia">                            
                        <span class="icon mr-2">
                            <fa-icon [icon]="faExclamationCircle" size="lg" routerLink="/dashboard" [queryParams]="{pendencia: true}"></fa-icon>
                        </span>
                    </a>
                        
                    <div class="navbar-item has-dropdown is-hoverable">                     

                        <a class="navbar-link">
                            <span class="icon"><fa-icon [icon]="faUser" size="lg"></fa-icon></span>
                        </a>
                
                        <div class="navbar-dropdown  is-right">
                            <a class="navbar-item" routerLink="/dashboard">
                                meus testamentos
                            </a>                            
                            <hr class="navbar-divider">
                            <a class="navbar-item" routerLink="/user">
                                minha conta
                            </a>
                            <a class="navbar-item" routerLink="/user/senha">
                                senha
                            </a>
                            <a class="navbar-item" (click)="logout()">
                            sair
                            </a>
                        </div>
                    </div>
                </div>
                <div *ngIf="!logado" class="navbar-end">
                    <div class="navbar-item">
                        <div class="buttons">
                            <a class="button is-link mr-2" routerLink="/registro">
                                registrar
                            </a>
                            <a class="button is-primary" routerLink="/login">
                                logar
                            </a>
                        </div>
                    </div>
                </div>                
            </div>
        </nav>
    </div>
</div>